export default "__VITE_ASSET__Cx45ZElT__"